export default "__VITE_ASSET__4dab73cb__"